const getOrgUrl = (orgId: string) =>
    `${process.env.REACT_APP_TREEZ_ORG_URL}/${orgId}`;

export const getOrganization = async ({
    accessToken,
    orgId,
}: {
    accessToken: string;
    orgId: string;
}) => {
    const response = await fetch(getOrgUrl(orgId), {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        throw new Error("Failed to fetch organization");
    }
    return response.json();
};
